import { COMMON_ERRORS } from 'modules/common/constants/errors.references';

export const ERROR_REFS = {
  ...COMMON_ERRORS,
  INVALID_ORDER_STATUS: 'INVALID_ORDER_STATUS',
  REQUIRED_SUB_CAUSE: 'IRC0003',
  REFUND_EXISTS: 'IRT0001',
  PRODUCT_NO_AVAILABLE: 'CT0003',
  ALREADY_CANCELED: 'ALREADY_CANCELED',
  INVALID_REFUND_AMOUNT: 'INVALID_REFUND_AMOUNT',
  INVALID_REFUND_LINES: 'INVALID_REFUND_LINES',
  INVALID_REPLACEMENT_LINES: 'INVALID_REPLACEMENT_LINES',
  REPLACEMENT_PRODUCT_NOT_AVAILABLE: 'REPLACEMENT_PRODUCT_NOT_AVAILABLE',
  COMBO_COMPONENTS_REQUIRED: 'COMBO_COMPONENTS_REQUIRED',
  COMPONENT_PRICE_REQUIRED: 'COMPONENT_PRICE_REQUIRED',
  REFUND_EXCEEDS_PAID: 'REFUND_EXCEEDS_PAID',
  COMPONENT_REFUND_EXCEEDS_PAID: 'COMPONENT_REFUND_EXCEEDS_PAID',
  COMPONENT_SPLIT_EXCEEDS_ORDERED: 'COMPONENT_SPLIT_EXCEEDS_ORDERED',
  COMPONENT_NOT_IN_COMBO: 'COMPONENT_NOT_IN_COMBO',
  COMPONENT_DUPLICATED: 'COMPONENT_DUPLICATED',
};

export const INCIDENCE_RESOLUTION_ERRORS = {
  [ERROR_REFS.DUPLICATE_KEY]: {
    title: 'incidenceResolution:errors.duplicatedName',
    description: 'incidenceResolution:errors.duplicatedNameDescription',
  },
  [ERROR_REFS.INVALID_ORDER_STATUS]: {
    description: 'incidenceResolution:errors.INVALID_ORDER_STATUS',
  },
  [ERROR_REFS.ALREADY_CANCELED]: {
    description: 'incidenceResolution:errors.ALREADY_CANCELED',
  },
  [ERROR_REFS.REQUIRED_SUB_CAUSE]: {
    description: 'errors:requiredSubCause',
  },
  [ERROR_REFS.REFUND_EXISTS]: {
    description: 'errors:refundExists',
  },
  [ERROR_REFS.PRODUCT_NO_AVAILABLE]: {
    description: 'incidence:errors.CT0003',
  },
  [ERROR_REFS.INVALID_REFUND_AMOUNT]: {
    title: 'errors:INVALID_REFUND_AMOUNT.title',
    description: 'errors:INVALID_REFUND_AMOUNT.description',
  },
  [ERROR_REFS.INVALID_REFUND_LINES]: {
    title: 'errors:INVALID_REFUND_LINES.title',
    description: 'errors:INVALID_REFUND_LINES.description',
  },
  [ERROR_REFS.INVALID_REPLACEMENT_LINES]: {
    title: 'errors:INVALID_REPLACEMENT_LINES.title',
    description: 'errors:INVALID_REPLACEMENT_LINES.description',
  },
  [ERROR_REFS.REPLACEMENT_PRODUCT_NOT_AVAILABLE]: {
    title: 'errors:REPLACEMENT_PRODUCT_NOT_AVAILABLE.title',
    description: 'errors:REPLACEMENT_PRODUCT_NOT_AVAILABLE.description',
  },
  [ERROR_REFS.COMBO_COMPONENTS_REQUIRED]: {
    description: 'errors:COMBO_COMPONENTS_REQUIRED',
  },
  [ERROR_REFS.COMPONENT_PRICE_REQUIRED]: {
    description: 'errors:COMPONENT_PRICE_REQUIRED',
  },
  [ERROR_REFS.REFUND_EXCEEDS_PAID]: {
    title: 'errors:REFUND_EXCEEDS_PAID.title',
    description: 'errors:REFUND_EXCEEDS_PAID.description',
  },
  [ERROR_REFS.COMPONENT_REFUND_EXCEEDS_PAID]: {
    title: 'errors:COMPONENT_REFUND_EXCEEDS_PAID.title',
    description: 'errors:COMPONENT_REFUND_EXCEEDS_PAID.description',
  },
  [ERROR_REFS.COMPONENT_SPLIT_EXCEEDS_ORDERED]: {
    title: 'errors:COMPONENT_SPLIT_EXCEEDS_ORDERED.title',
    description: 'errors:COMPONENT_SPLIT_EXCEEDS_ORDERED.description',
  },
  [ERROR_REFS.COMPONENT_NOT_IN_COMBO]: {
    description: 'errors:COMPONENT_NOT_IN_COMBO',
  },
  [ERROR_REFS.COMPONENT_DUPLICATED]: {
    description: 'errors:COMPONENT_DUPLICATED',
  },
};
